export { default as getInternalDataPaginated } from './getInternalDataPaginated';
